import { TextField, type TextFieldProps } from "@mui/material";
import { formatPhoneInput, normalizePhone } from "@/shared/utils/formatPhone";

type PhoneFieldProps = {
  /** Normalized 10-digit value held in form state (e.g. "5321234567"). */
  value: string;
  /** Receives the normalized (≤10 digit) value on every change. */
  onChange: (normalized: string) => void;
} & Omit<TextFieldProps, "value" | "onChange">;

/**
 * MUI TextField wrapper for Turkish mobile numbers. Displays a live masked value
 * — (532) 123 45 67 — while keeping form state as a bare normalized 10-digit string,
 * so existing submit/validation against ^[0-9]{10}$ keeps working unchanged.
 */
export const PhoneField = ({ value, onChange, ...rest }: PhoneFieldProps) => (
  <TextField
    {...rest}
    value={formatPhoneInput(value)}
    onChange={(e) => onChange(normalizePhone(e.target.value))}
    placeholder={rest.placeholder ?? "(5XX) XXX XX XX"}
    inputMode="tel"
    inputProps={{ maxLength: 15, ...rest.inputProps }} // "(532) 123 45 67" = 15 chars
  />
);
